import { useFormikContext } from 'formik';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Input from '../../../../../../components/Input/Input';
import { roundToFour } from '../../Geometry/utils';
import { IFormikForm } from '../ModalMaterial/FormikMaterial';
import { CheckForAllMats } from '../MaterialDataCheckboxes/CheckForAllMats';

interface IConcreteProps {
    hideForALl?: boolean;
}

const Concrete = (props: IConcreteProps) => {
    const { t } = useTranslation();
    const { values, setFieldValue } = useFormikContext<IFormikForm>();

    const handleRoughnessChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFieldValue(`${values.sectorChannel}.roughness`, roundToFour(parseFloat(e.target.value)));
    };

    return (
        <>
            {!props.hideForALl && <CheckForAllMats />}
            <div className='d-flex justify-content-between mt-2 gap-2'>
                <Input
                    title={t('material_roughness')}
                    type='number'
                    name={`${values.sectorChannel}.roughness`}
                    value={values[values.sectorChannel].roughness}
                    onChange={e => handleRoughnessChange(e)}
                />
            </div>
        </>
    );
};

export default Concrete;
